import React from "react";

// Images (relative to: src/components/landing/Team.tsx)
import AlyssaCard from "../../assets/Alyssa card.png";
import AlexCard from "../../assets/Alex card.png";
import TrinityCard from "../../assets/Trinity card.png";

export default function Team() {
  const members = [
    { name: "Alyssa",  href: "/team/alyssa",  img: AlyssaCard,  alt: "Alyssa profile card" },
    { name: "Alex",    href: "/team/alex",    img: AlexCard,    alt: "Alex profile card" },
    { name: "Trinity", href: "/team/trinity", img: TrinityCard, alt: "Trinity profile card" },
  ];

  return (
    <section id="team" className="py-16 bg-[#080D1B] text-center">
      <h1 className="text-5xl font-bold text-[#dee3f2] mb-2">
        Meet the <span className="text-[#2B61DE]">Team</span>
      </h1>
      <h6 className="text-sm text-[#B1BFE4] mb-10">Select a Card to See More!</h6>

      <div className="mx-auto flex flex-wrap items-center justify-center gap-24 px-6">
        {members.map((m) => (
          <a
            key={m.name}
            href={m.href}
            aria-label={`${m.name} personal page`}
            className="group relative inline-block transform transition-transform duration-300 hover:scale-105 will-change-transform origin-center"
          >
            {/* Blue glow behind the card on hover (square edges) */}
            <div className="pointer-events-none absolute -inset-3 bg-[#2B61DE] opacity-0 blur-2xl transition duration-300 group-hover:opacity-40" />

            {/* Image preserves original aspect ratio and is capped by max size (no cropping) */}
            <img
              src={m.img}
              alt={m.alt}
              className="relative z-10 block select-none h-auto w-auto max-w-[320px] max-h-[420px]"
              draggable={false}
              loading="lazy"
            />
          </a>
        ))}
      </div>
    </section>
  );
}
